import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { LockIcon, Select as DefaultSelect } from 'components'
import ImageIcon from './ImageIcon'

const Select = ({ options, placeholder, iconImg, iconImgAlt, disabled, onClick, ...rest }) => (
  <div className="w-full relative mt-2.5" onClick={onClick}>
    <ImageIcon className="left-8" iconImg={iconImg} iconImgAlt={iconImgAlt} />
    {disabled && (
      <div className="bg-transparent absolute top-1/2 right-4 transform -translate-y-1/2 z-10 flex justify-center items-center bg-black rounded-full w-7 h-7">
        <LockIcon className="w-2.5" />
      </div>
    )}
    <DefaultSelect
      disabled={disabled}
      classNames={{
        select: 'bg-midnightBlack border-0 rounded-3xl pl-20 py-5 text-base',
        label: '',
        chevron: classnames('right-6', { 'opacity-0': disabled }),
      }}
      {...rest}
    >
      <option value="">{placeholder}</option>
      {options.map(({ value, label }) => (
        <option key={`${value}-${label}`} value={value}>
          {label}
        </option>
      ))}
    </DefaultSelect>
  </div>
)

Select.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  iconImg: PropTypes.string,
  iconImgAlt: PropTypes.string,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export default Select
